export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_tr-36145fc8.png";